import { css } from '@/styled-system/css';

export const cardContentStyles = css.raw({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignItems: 'center',
  height: '100%',
  color: 'bg.soft',
  // Removed padding from Card.Root and added it here to allow onClick to be called from the entire card
  padding: 'default',
});

export const childContentContainerStyles = css.raw({
  flexGrow: 1,
  width: '100%',
  height: '100%',
  /**
   * fixes this content pushing the chevron beyond container
   * ref: https://css-tricks.com/flexbox-truncated-text/#aa-the-solution-is-min-width-0-on-the-flex-child
   */
  minWidth: 0,
  overflow: 'hidden',
});
